import { createAsyncThunk } from '@reduxjs/toolkit';
import conveyorStepRecordCorrectionLogApi from '../../../api/conveyorStepRecordCorrectionLogApi';
import factoryOptionsApi from '../../../api/factoryOptionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'tobaccoCorrection';

export const GetCorrectionReasons = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getCorrectionReasons`,
  async (___, thunkAPI) => {
    const res = await factoryOptionsApi.getByName('correctionReasons');

    if (res.status === 200) {
      return res.data?.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateCorrectionLog = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/postCorrectionLog`,
  async (params, thunkAPI) => {
    const res = await conveyorStepRecordCorrectionLogApi.post(params);

    if (res.status === 200) {
      return { ...res.data };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
